import { DocumentTypeSelector } from "./document-type-selector.react";
import { Base, SectionTitle } from "@/atoms-react/text/Text.react";
import { useTranslation, Trans } from "react-i18next";
import type { KYCDocumentType } from "@/features/kyc/types";
import { useState } from "react";
import Column from "@/atoms-react/column/Column.react";
import { FormFooter } from "./form-footer.react";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react";
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";
import { ModalIbanAccountStep, stepSettingObjItem } from "@/features/user/quiz/types";

type DocumentTypeStepProps = {
  onValidated: (documentType: KYCDocumentType) => void;
  onPrevious: () => void;
  custom_scenario?: boolean;
  stepSettings?: stepSettingObjItem;
  setStep?: (next: ModalIbanAccountStep) => void;
  setPrevStep?: (step: ModalIbanAccountStep) => void;
};

export const DocumentTypeStep = ({
  onPrevious,
  onValidated,
  custom_scenario = false,
  stepSettings,
  setStep,
  setPrevStep
}: DocumentTypeStepProps) => {
  const { t } = useTranslation(["atoms", "pass"]);
  const [documentType, setDocumentType] = useState<KYCDocumentType | null>(null);
  return (
    <>
      <div className="mx-auto max-w-4xl px-4 py-4 text-center">
        <SectionTitle className="mb-4 text-base">
          {t("molecules.modal_kyc_identity.step2_title")}
        </SectionTitle>
        <Base className="font-medium text-gray-400">
          <Trans
            i18nKey={"molecules.modal_kyc_identity.step2_content"}
            ns={"atoms"}
            components={{ span: <span className="font-semibold text-primary" /> }}
          />
        </Base>
        <Column className="mt-6 gap-2 text-left">
          <Base className="font-semibold text-gray-800">
            {t("molecules.modal_kyc_identity.document_type")}
          </Base>
          <DocumentTypeSelector
            dataCy="kyc-document-selector"
            onDocumentSelected={(documentType) => setDocumentType(documentType)}
          />
        </Column>
      </div>
      {!custom_scenario ? (
        <FormFooter
          onPrevious={onPrevious}
          onNext={() => documentType && onValidated(documentType)}
          nextDisabled={!documentType}
          currentStep={1}
        />
      ) : (
        <div className="mt-auto mb-4 flex flex-col items-center">
          <DotsNavigation total={14} current={stepSettings?.current} className="mb-4" />
          <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
            <Button
              theme={Themes.white}
              onClick={() => setPrevStep?.(stepSettings?.previous as ModalIbanAccountStep)}
            >
              {t("pass:olkypass.general.go_back")}
            </Button>

            <Button
              disabled={!documentType}
              onClick={() => {
                if (!documentType) return;
                setStep?.(stepSettings?.next as ModalIbanAccountStep);
              }}
            >
              {t("pass:olkypass.general.continue")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
